import { Injectable } from '@angular/core';
import { Observable, from } from 'rxjs';
import { map } from 'rxjs/operators';
import { ContentfulApiService } from './contentful-api.service';
import { Asset, Entry } from 'contentful-management';
import { FileModel } from '../../models/entities/file.model';

@Injectable({
    providedIn: "root",
})
export class FileService {
    private readonly ContentTypeId = "file";

    constructor(private contentfulApiService: ContentfulApiService) {}

    getAll(): Observable<FileModel[]> {
        return from(
            this.contentfulApiService.getEntries(this.ContentTypeId)
        ).pipe(
            map((items: Entry[]) => {
                const files: FileModel[] = items.map((item) => {
                    return this.mapDtoToModel(item);
                });

                return files;
            })
        );
    }

    getUrlFromAsset(assetId :string): Observable<string> {        
        return from(this.contentfulApiService.getAsset(assetId)).pipe(
            map((asset: Asset) => {
                const fileUrl = asset.fields.file["en-US"].url;            
                return fileUrl;
            })
        );
    }

    create(data: FileModel): Promise<any> {
        const fields = {
            id: { "en-US": data.id },
            name: { "en-US": data.name },
            description: { "en-US": data.description },
            source: { "en-US": data.sourceId },
            env: { "en-US": data.env },
        };

        return this.contentfulApiService.createEntry(
            this.ContentTypeId,
            fields
        );
    }

    mapDtoToModel(dto: any) {
        const asset = dto.fields.source["en-US"].sys.id;
        return {
            id: dto.fields["id"]["en-US"],
            name: dto.fields["name"]["en-US"],
            description: dto.fields["description"]["en-US"],
            sourceId: dto.fields.source["en-US"].sys.id,
            env: dto.fields["env"]["en-US"],
        } as FileModel;
    }
}
